function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const colors = {
  error: "var(--notification-error)",
  warning: "var(--notification-warning)",
  information: "var(--notification-information)",
  info: "var(--notification-information)",
  success: "var(--notification-success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-reversed)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const AwsCircleIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "AWS",
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "AWS"
}, "AWS"), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--background-content)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.0674 31.451C25.0584 31.8008 25.1015 32.15 25.1954 32.487C25.2986 32.7751 25.423 33.0552 25.5674 33.325C25.6191 33.4049 25.6471 33.4978 25.6484 33.593C25.6412 33.6644 25.6175 33.7331 25.5792 33.7937C25.5408 33.8542 25.4888 33.905 25.4274 33.942L24.6944 34.431C24.6061 34.4926 24.5019 34.5273 24.3944 34.531C24.2619 34.5218 24.1375 34.4637 24.0454 34.368C23.8885 34.1995 23.7482 34.0163 23.6264 33.821C23.5104 33.621 23.3934 33.402 23.2654 33.134C22.8558 33.6471 22.3342 34.0596 21.7405 34.3399C21.1468 34.6202 20.4968 34.7608 19.8404 34.751C19.4161 34.7734 18.9916 34.7108 18.5918 34.5669C18.1921 34.423 17.8251 34.2007 17.5124 33.913C17.2226 33.6199 16.9965 33.2701 16.8483 32.8855C16.7001 32.5009 16.6331 32.0898 16.6514 31.678C16.6346 31.2239 16.7212 30.7719 16.9047 30.3561C17.0881 29.9404 17.3636 29.5717 17.7104 29.278C18.5188 28.6383 19.5329 28.3155 20.5624 28.37C20.9753 28.3733 21.3876 28.4044 21.7964 28.463C22.2274 28.521 22.6694 28.614 23.1354 28.719V27.869C23.2024 27.2008 23.0062 26.5328 22.5884 26.007C22.0462 25.5934 21.3667 25.402 20.6884 25.472C20.2649 25.4719 19.8428 25.5226 19.4314 25.623C19.0034 25.7263 18.5834 25.86 18.1744 26.023C18.0421 26.0821 17.9062 26.1326 17.7674 26.174C17.7072 26.1939 17.6447 26.2057 17.5814 26.209C17.4184 26.209 17.3374 26.093 17.3374 25.848V25.271C17.3248 25.1304 17.353 24.9891 17.4184 24.864C17.5062 24.7581 17.618 24.6744 17.7444 24.62C18.2113 24.3886 18.7036 24.2124 19.2114 24.095C19.8046 23.9429 20.415 23.8686 21.0274 23.874C22.1279 23.7805 23.2217 24.1186 24.0774 24.817C24.4232 25.2046 24.687 25.6581 24.853 26.1503C25.019 26.6425 25.0838 27.1632 25.0434 27.681V31.451H25.0674ZM20.3414 33.222C20.7501 33.2175 21.1554 33.1466 21.5414 33.012C21.9687 32.8643 22.3499 32.6075 22.6474 32.267C22.8365 32.0529 22.9734 31.7979 23.0474 31.522C23.1273 31.1903 23.1662 30.8501 23.1634 30.509V30.02C22.8104 29.9334 22.4528 29.8666 22.0924 29.82C21.7295 29.7739 21.3642 29.7505 20.9984 29.75C20.384 29.7017 19.7717 29.8662 19.2644 30.216C19.0716 30.3794 18.9197 30.5855 18.8208 30.818C18.7218 31.0505 18.6785 31.3028 18.6944 31.555C18.6682 31.7789 18.6929 32.0059 18.7666 32.2189C18.8402 32.432 18.9609 32.6257 19.1198 32.7857C19.2786 32.9457 19.4715 33.0678 19.684 33.143C19.8965 33.2182 20.1233 33.2445 20.3474 33.22L20.3414 33.222ZM29.6884 34.479C29.5319 34.4951 29.3748 34.4539 29.2464 34.363C29.1247 34.2371 29.0403 34.08 29.0024 33.909L26.2664 24.909C26.2149 24.7581 26.1813 24.6017 26.1664 24.443C26.1606 24.4049 26.1636 24.366 26.1751 24.3292C26.1866 24.2924 26.2062 24.2587 26.2326 24.2306C26.259 24.2025 26.2914 24.1807 26.3273 24.1669C26.3633 24.1532 26.402 24.1477 26.4404 24.151H27.5814C27.7419 24.1314 27.9039 24.1728 28.0354 24.267C28.1529 24.3943 28.2335 24.5513 28.2684 24.721L30.2244 32.427L32.0394 24.724C32.0632 24.5531 32.1406 24.3942 32.2604 24.27C32.3998 24.1835 32.5625 24.1419 32.7264 24.151H33.6574C33.8202 24.1356 33.9833 24.1777 34.1184 24.27C34.2401 24.3928 34.3178 24.5524 34.3394 24.724L36.1784 32.524L38.1924 24.724C38.2295 24.5551 38.3098 24.3986 38.4254 24.27C38.5617 24.1823 38.7226 24.1406 38.8844 24.151H39.9674C40.0068 24.1457 40.047 24.1496 40.0847 24.1624C40.1224 24.1752 40.1567 24.1964 40.1848 24.2246C40.2129 24.2527 40.2342 24.287 40.247 24.3247C40.2598 24.3624 40.2636 24.4026 40.2584 24.442C40.2557 24.5045 40.248 24.5667 40.2354 24.628C40.2172 24.7273 40.1901 24.8247 40.1544 24.919L37.3494 33.919C37.3142 34.0912 37.2289 34.2491 37.1044 34.373C36.9729 34.4571 36.8182 34.4977 36.6624 34.489H35.6624C35.4982 34.5065 35.3332 34.4654 35.1964 34.373C35.0747 34.2453 34.9973 34.082 34.9754 33.907L33.1754 26.399L31.3824 33.899C31.3552 34.0724 31.2784 34.2342 31.1614 34.365C31.0238 34.4557 30.8594 34.4966 30.6954 34.481L29.6884 34.479ZM44.6464 34.793C44.0425 34.7936 43.4407 34.7231 42.8534 34.583C42.3882 34.4883 41.9378 34.3316 41.5144 34.117C41.3645 34.0464 41.2388 33.933 41.1534 33.791C41.108 33.6883 41.0842 33.5773 41.0834 33.465V32.872C41.0834 32.628 41.1764 32.511 41.3514 32.511C41.4225 32.5113 41.4931 32.5231 41.5604 32.546C41.6304 32.569 41.7354 32.616 41.8514 32.662C42.2624 32.8427 42.6915 32.9791 43.1314 33.069C43.5872 33.1616 44.0512 33.2085 44.5164 33.209C45.1085 33.2447 45.6986 33.1119 46.2184 32.826C46.407 32.7109 46.5619 32.548 46.6673 32.3538C46.7726 32.1595 46.8248 31.9409 46.8184 31.72C46.8226 31.5701 46.797 31.4209 46.7431 31.281C46.6892 31.1411 46.608 31.0133 46.5044 30.905C46.1638 30.616 45.7615 30.4091 45.3284 30.3L43.6404 29.776C42.9093 29.5883 42.2571 29.1725 41.7784 28.589C41.4037 28.1059 41.199 27.5124 41.1964 26.901C41.1893 26.4496 41.3003 26.0043 41.5184 25.609C41.7249 25.2336 42.0097 24.9069 42.3534 24.651C42.7165 24.3785 43.1267 24.1751 43.5634 24.051C44.04 23.913 44.5342 23.8456 45.0304 23.851C45.2911 23.8493 45.5517 23.865 45.8104 23.898C46.0784 23.933 46.3224 23.979 46.5674 24.026C46.8124 24.073 47.0214 24.142 47.2314 24.212C47.4005 24.2645 47.5638 24.3346 47.7184 24.421C47.8554 24.4902 47.9747 24.5897 48.0674 24.712C48.1414 24.8258 48.1765 24.9606 48.1674 25.096V25.643C48.1674 25.887 48.0744 26.015 47.8994 26.015C47.7444 25.9972 47.5943 25.9497 47.4574 25.875C46.7539 25.564 45.9914 25.4092 45.2224 25.421C44.6865 25.3892 44.1519 25.5018 43.6744 25.747C43.4968 25.8527 43.3517 26.0053 43.2552 26.1881C43.1587 26.3709 43.1145 26.5767 43.1274 26.783C43.1243 26.9375 43.1538 27.0909 43.2139 27.2332C43.274 27.3755 43.3635 27.5036 43.4764 27.609C43.8541 27.9088 44.2899 28.1267 44.7564 28.249L46.4094 28.773C47.1128 28.9517 47.7444 29.3424 48.2184 29.892C48.5736 30.3604 48.7619 30.9342 48.7534 31.522C48.7602 31.9893 48.6574 32.4516 48.4534 32.872C48.2467 33.2703 47.9568 33.6195 47.6034 33.896C47.2191 34.1951 46.7803 34.4166 46.3114 34.548C45.7721 34.7137 45.2106 34.796 44.6464 34.792V34.793Z",
  fill: "var(--third-party-aws-text)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.8461 40.451C42.6637 43.2885 37.7222 44.7976 32.6681 44.781C26.2774 44.8143 20.1044 42.4607 15.3581 38.181C14.9971 37.855 15.3231 37.413 15.7581 37.669C21.0331 40.6836 27.0035 42.2692 33.0791 42.269C37.6177 42.2452 42.1071 41.3277 46.2911 39.5691C46.9271 39.2751 47.4741 39.985 46.8461 40.451ZM48.4411 38.6351C47.9521 38.0061 45.2051 38.3351 43.9591 38.4841C43.5861 38.5311 43.5281 38.205 43.8661 37.96C46.0541 36.423 49.6511 36.866 50.0661 37.378C50.4811 37.89 49.9501 41.4991 47.9011 43.2221C47.5871 43.4901 47.2841 43.35 47.4241 43.001C47.8901 41.849 48.9241 39.2531 48.4371 38.6361L48.4411 38.6351Z",
  fill: "var(--third-party-aws-smile)"
}));
export const AwsIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "AWS",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.00003802776336669922 -0.00038831596611998975 34.38534164428711 20.936731338500977"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "AWS"
}, "AWS"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--third-party-aws-text)",
  d: "M9.69 7.604c-.01.35.033.701.126 1.04.101.287.223.568.365.838.05.08.078.172.08.268a.462.462 0 01-.219.35l-.72.488a.542.542 0 01-.298.105.523.523 0 01-.343-.163 3.596 3.596 0 01-.412-.547 9.039 9.039 0 01-.355-.687 4.195 4.195 0 01-3.359 1.603 3.102 3.102 0 01-2.287-.838 3.021 3.021 0 01-.847-2.236 3.022 3.022 0 011.041-2.399 4.111 4.111 0 012.8-.908c.406.003.81.034 1.212.092.423.058.858.149 1.313.257v-.85a2.613 2.613 0 00-.533-1.864 2.599 2.599 0 00-1.864-.535 5.115 5.115 0 00-1.235.148c-.42.102-.833.234-1.235.396-.13.058-.264.108-.4.148a.69.69 0 01-.184.035c-.16 0-.24-.116-.24-.36V1.42a.748.748 0 01.08-.407.857.857 0 01.32-.245A6.505 6.505 0 013.939.244 6.816 6.816 0 015.721.022a4.128 4.128 0 012.996.943 3.898 3.898 0 01.948 2.864v3.773l.024.002zm-4.646 1.77a3.648 3.648 0 001.177-.21 2.55 2.55 0 001.087-.743 1.86 1.86 0 00.388-.742c.08-.333.12-.676.118-1.019v-.489a9.399 9.399 0 00-1.052-.198 8.466 8.466 0 00-1.074-.07 2.602 2.602 0 00-1.705.466c-.383.33-.59.825-.56 1.336a1.52 1.52 0 00.416 1.23 1.46 1.46 0 001.205.438zm9.187 1.257a.63.63 0 01-.437-.117.954.954 0 01-.24-.454l-2.687-9a2.064 2.064 0 01-.102-.466.258.258 0 01.067-.214.248.248 0 01.207-.077h1.121a.626.626 0 01.447.116.959.959 0 01.229.455l1.92 7.708L16.54.873c.024-.171.1-.33.218-.454a.775.775 0 01.458-.117h.915a.679.679 0 01.457.117.79.79 0 01.219.454l1.804 7.801 1.979-7.8a.993.993 0 01.229-.455.736.736 0 01.446-.117h1.064a.252.252 0 01.213.074.262.262 0 01.072.218 1.691 1.691 0 01-.103.477l-2.756 9.001a.896.896 0 01-.24.455.72.72 0 01-.438.116h-.98a.679.679 0 01-.458-.116.831.831 0 01-.218-.466l-1.772-7.51-1.76 7.498a.916.916 0 01-.22.465.699.699 0 01-.456.117h-.982zm14.696.314a7.44 7.44 0 01-1.761-.21 5.14 5.14 0 01-1.313-.465.829.829 0 01-.354-.326.835.835 0 01-.069-.326v-.594c0-.244.092-.36.264-.36.07 0 .139.011.205.034.069.023.172.07.286.117a6.2 6.2 0 001.258.407c.448.093.904.14 1.361.14a3.04 3.04 0 001.67-.385 1.26 1.26 0 00.595-1.106 1.145 1.145 0 00-.31-.816 2.85 2.85 0 00-1.154-.606l-1.666-.522a3.482 3.482 0 01-1.829-1.188 2.807 2.807 0 01-.572-1.688 2.63 2.63 0 01.31-1.293c.204-.375.484-.7.823-.955.357-.274.76-.48 1.19-.605A4.901 4.901 0 0129.303 0c.256-.002.512.014.766.047.263.035.503.081.743.128.229.058.446.117.652.187.166.052.328.122.48.209.135.069.252.169.344.291.074.113.11.248.102.385v.547c0 .244-.09.37-.263.37a1.174 1.174 0 01-.437-.139 5.152 5.152 0 00-2.196-.454 2.907 2.907 0 00-1.521.326 1.13 1.13 0 00-.537 1.04 1.11 1.11 0 00.343.826c.371.3.8.519 1.258.641l1.624.524a3.47 3.47 0 011.775 1.115c.35.47.535 1.045.526 1.634.006.467-.096.93-.298 1.35a3.12 3.12 0 01-.834 1.025c-.378.299-.81.52-1.27.652a5.348 5.348 0 01-1.635.244l.002-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--third-party-aws-smile)",
  d: "M31.087 16.604c-3.763 2.83-9.23 4.332-13.928 4.332-6.278.033-12.343-2.321-17.007-6.602-.354-.326-.034-.768.389-.512a33.823 33.823 0 0017.017 4.603 33.436 33.436 0 0012.979-2.702c.63-.295 1.168.416.55.881zm1.567-1.816c-.481-.63-3.18-.303-4.403-.149-.365.047-.423-.279-.091-.524 2.15-1.537 5.684-1.094 6.095-.582.412.524-.115 4.122-2.127 5.845-.309.268-.606.128-.469-.223.457-1.153 1.475-3.749.995-4.366v-.001z"
})));
export const AzureCircleIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Azure",
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Azure"
}, " Azure"), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--background-content)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.3246 32.325H23.4326V23.433H32.3246V32.325Z",
  fill: "#F1511B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.1 32.325H33.208V23.433H42.099V32.325H42.1Z",
  fill: "#80CC28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.3246 42.1H23.4326V33.208H32.3246V42.1Z",
  fill: "#00ADEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.1 42.1H33.208V33.208H42.099V42.1H42.1Z",
  fill: "#FBBC09"
}));
export const AzureIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Azure",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0.2900000214576721 23.996999740600586 24.433998107910156"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Azure"
}, " Azure"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F1511B",
  d: "M11.43 11.928H0V.29h11.43z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#80CC28",
  d: "M23.997 11.928h-11.43V.29h11.43v11.638z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00ADEF",
  d: "M11.43 24.724H0V13.085h11.43z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC09",
  d: "M23.997 24.724h-11.43V13.085h11.43v11.639z"
})));
export const GcpCircleIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "GCP",
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "GCP"
}, "GCP"), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--background-content)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.9664 28.166H36.0454L35.9974 28.127L38.9854 25.139L38.9914 25.085C37.7533 23.993 36.2574 23.2345 34.6448 22.8812C33.0323 22.5279 31.3563 22.5914 29.775 23.0656C28.1938 23.5399 26.7595 24.4093 25.6076 25.5918C24.4557 26.7743 23.6241 28.2309 23.1914 29.824C23.2435 29.803 23.2969 29.7856 23.3514 29.772C24.8794 28.7596 26.7448 28.39 28.5434 28.743C28.5617 28.73 28.5841 28.7243 28.6064 28.727C29.5324 27.7093 30.8126 27.0843 32.1846 26.9802C33.5566 26.8761 34.9164 27.3007 35.9854 28.167H35.9664",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.9678 29.82C41.4695 27.9915 40.4497 26.3476 39.0328 25.089L36.0018 28.126C36.634 28.6427 37.1406 29.2963 37.4834 30.0373C37.8262 30.7784 37.9963 31.5876 37.9808 32.404V32.941C38.6969 32.941 39.3836 33.2255 39.89 33.7318C40.3963 34.2381 40.6808 34.9249 40.6808 35.641C40.6808 36.3571 40.3963 37.0438 39.89 37.5502C39.3836 38.0565 38.6969 38.341 37.9808 38.341H32.5808L32.5728 38.35V42.635H32.5498L32.5808 42.666H37.9808C39.4898 42.6784 40.9627 42.2045 42.1814 41.3145C43.4001 40.4244 44.2997 39.1655 44.747 37.7243C45.1943 36.283 45.1656 34.736 44.665 33.3124C44.1644 31.8887 43.2187 30.6641 41.9678 29.82",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.1736 42.635H32.5736V38.314H27.1736C26.7907 38.3141 26.4123 38.2311 26.0646 38.071L22.9426 41.192L22.9346 41.225C24.1553 42.1459 25.6444 42.6412 27.1736 42.635",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.1738 28.617C25.7121 28.6271 24.29 29.093 23.1058 29.9499C21.9216 30.8068 21.0343 32.0118 20.5677 33.397C20.101 34.7822 20.0783 36.2785 20.5026 37.6773C20.9269 39.0761 21.7772 40.3075 22.9348 41.2L26.0678 38.069C25.6693 37.8895 25.3204 37.616 25.051 37.272C24.7815 36.928 24.5996 36.5237 24.5208 36.0939C24.442 35.664 24.4688 35.2215 24.5987 34.8043C24.7287 34.3871 24.9579 34.0076 25.2669 33.6985C25.5758 33.3894 25.9551 33.1599 26.3722 33.0298C26.7894 32.8996 27.2319 32.8726 27.6618 32.9511C28.0917 33.0297 28.4961 33.2114 28.8402 33.4806C29.1844 33.7499 29.4581 34.0987 29.6378 34.497L32.7698 31.366C32.112 30.5075 31.2647 29.8126 30.2939 29.3357C29.3232 28.8589 28.2553 28.6129 27.1738 28.617Z",
  fill: "#FBBC05"
}));
export const GcpIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "GCP",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.008762270212173462 0.29384422302246094 29.272241592407227 23.986434936523438"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "GCP"
}, "GCP"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M18.573 6.897h.093l-.057-.047 3.517-3.58.008-.065A11.284 11.284 0 0011.283.783C7.498 1.938 4.567 5 3.53 8.884c.06-.025.122-.046.184-.063a8.086 8.086 0 016.113-1.234.105.105 0 01.075-.02 6.264 6.264 0 018.686-.672h-.019"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M25.641 8.885a11.733 11.733 0 00-3.455-5.67l-3.575 3.634a6.513 6.513 0 012.33 5.131v.644c4.237 0 4.237 6.472 0 6.472h-6.356l-.01.01v5.136h-.026l.037.038h6.357c3.647.03 6.883-2.375 7.965-5.92 1.082-3.547-.245-7.396-3.267-9.475"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M8.22 24.24h6.354v-5.177H8.22c-.45 0-.896-.1-1.305-.292L3.24 22.512l-.01.04a8.134 8.134 0 004.991 1.691"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M8.215 7.437c-3.527.026-6.65 2.328-7.774 5.732-1.125 3.404-.005 7.16 2.79 9.352l3.692-3.754c-1.292-.59-2.045-1.977-1.848-3.404.197-1.428 1.297-2.55 2.699-2.753a3.167 3.167 0 013.346 1.876l3.688-3.753a8.209 8.209 0 00-6.593-3.296"
})));
export const NetAppCircleIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-NetApp",
  width: 62,
  height: 66,
  viewBox: "0 0 62 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-NetApp"
}, " NetApp"), /*#__PURE__*/React.createElement("path", {
  d: "M31.1342 65C47.7768 65 61.2683 50.6731 61.2683 33C61.2683 15.3269 47.7768 1 31.1342 1C14.4915 1 1 15.3269 1 33C1 50.6731 14.4915 65 31.1342 65Z",
  className: "circle-icon-shadow",
  fill: "var(--background-content)",
  stroke: "var(--icon-round-border)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 43H28V31H34V43H43V23H19V43Z",
  fill: "black"
}));
export const OnpremCircleIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "On-premises",
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "On-premises"
}, "On-premises"), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--background-content)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.5 24.5V31.967H16.5V24.5H48.5ZM46.5 27.3H44.5V29.167H46.5V27.3ZM42.5 27.3H40.5V29.167H42.5V27.3ZM38.5 27.3H36.5V29.167H38.5V27.3Z",
  fill: "#5498E0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.5 33.033V40.5H16.5V33.033H48.5ZM46.5 35.833H44.5V37.7H46.5V35.833ZM42.5 35.833H40.5V37.7H42.5V35.833ZM38.5 35.833H36.5V37.7H38.5V35.833Z",
  fill: "#3279C5"
}));
export const OnpremIcon = ({
  color = undefined,
  size = undefined,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "On-premises",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 18.200000762939453"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "On-premises"
}, "On-premises"), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 8.667,
  fill: "#5498E0",
  rx: 1.733
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.8,
  cy: 5.2,
  r: 1.733,
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 8.667,
  y: 9.533,
  fill: "#2C6BCC",
  rx: 1.733
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.8,
  cy: 13,
  r: 1.733,
  fill: "#F1F1F1"
}));